import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import 'react-vant/es/styles';
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import localstorage from 'src/helper/localstorage'
import ReminderBtn from 'src/component/RuleButton'
import { jumpToUser } from 'src/helper/webviewFun'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: langM.en,
    targetValue: '',
    language:'en',
    userInfo: {
      "uid": 106879,
      "nickname": "测试6878",
      "duid": "106879",
      "avatarurl": "http://img.chatie.live/app/man.jpg",
      "gender": 2,
      "roleLevel": 3,
      "target": null,
    },
    checkVlaue: false,
    showPis: false,
    hostcheckVlaue: false
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    if (language == 'en') {
      setDocumentTitle("Host Info")
    } else if (language == 'ar') {
      setDocumentTitle(" معلومات المضيف")
    } else if (language == 'tr') {
      setDocumentTitle("Ajans Bilgisi")
    }

    // end
    let uid = await setUidToken(this.props.location.query)
    await this.getInfo()
  }
  getInfo = async () => {
    let { uid, hostSystemId, roleLevel } = localstorage.get('updataInfo')
    let res = await http.post('/web/hostsystem/user/get', { hostSystemId, uid })
    console.log(res)
    if (res.code == 0 && res.res) {
      this.setState({ userInfo: { ...res.res }, })
      if (roleLevel == 1) {
        this.setState({ showPis: true })
      }
      if (res.res.roleLevel == 2) {
        this.setState({ checkVlaue: true })
      }
      if (res.res.host == 1) {
        this.setState({ hostcheckVlaue: true })
      }
    }
  }
  componentWillUnmount() {
    localstorage.set('updataInfo', {})
  }
  showGoldModle = (open, close) => {
    let { userInfo, lang } = this.state
    console.log(this.state)

    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.yousure}</div>
        <div className="gold-modle-body">
          <div className="application-user-info">
            <div className="avatar-root">
              {userInfo && <img className="avatar-img" src={userInfo.avatarurl}></img>}
              {userInfo && userInfo.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
              {userInfo && userInfo.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
            </div>
            <div className="user-infos">
              <div className="user-info-top">
                {userInfo && <div className="top-text">{userInfo.nickname}</div>}

              </div>
              {userInfo && <div className="user-info-buttom">ID:{userInfo.duid}</div>}
            </div>

          </div>
        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.cancel}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.removeHost()}
          >
            {lang.confirmText}
          </div>
        </div>
      </div>
    )
  }
  setCheck = async (e) => {
    let { checkVlaue } = this.state

    await this.setState({ checkVlaue: !checkVlaue })
    this.upHost(!checkVlaue)
  }
  changeTarget = (e) => {
    if (e.target.value.length > 10) {
      document.querySelector('.target-num').value = this.state.targetValue
      return this.refs.msg.show(this.state.lang.cantten)
    }
    this.setState({ targetValue: e.target.value })
  }
  removeHost = async () => {
    let { uid, hostSystemId, roleLevel } = localstorage.get('updataInfo')
    let res = await http.post('/web/hostsystem/user/remove', { hostSystemId, uid })

    if (res.code == 0) {
      this.refs.msg.show(this.state.lang.sesmsg)
      history.go(-1)
    }
  }
  setCheckHost = async () => {
    let { hostcheckVlaue } = this.state
    await this.setState({ hostcheckVlaue: !hostcheckVlaue })
    this.upHost()
  }
  upHost = async (confi) => {
    let { uid, hostSystemId, roleLevel } = localstorage.get('updataInfo')
    let { targetValue, userInfo } = this.state
    let prams = { hostSystemId, uid, target: targetValue * 1 || userInfo.target,  bank: userInfo.bank, account: userInfo.account,  payeeName:userInfo.payeeName,}
    if (roleLevel == 4) {
      prams.roleLevel = 1
    } else if (roleLevel == 1 && this.state.checkVlaue) {
      prams.roleLevel = 2
    } else if (roleLevel == 1 && !this.state.checkVlaue) {
      prams.roleLevel = 3
    } else {
      prams.roleLevel = 3
    }
    if (this.state.hostcheckVlaue) {
      prams.host = 1
    } else if (!this.state.hostcheckVlaue) {
      prams.host = 0
    }
    let res = await http.post('/web/hostsystem/user/update', prams)
    if (res.code == 0) {
      this.refs.msg.show(this.state.lang.sesmsg)
      this.getInfo()
    }
  }
  render() {
    let { roleLevel } = localstorage.get('updataInfo')
    let { lang, checkVlaue, showPis, userInfo, hostcheckVlaue, language } = this.state
    return <div className={`host-info-edit ${isRtl(language) ? 'in-tr' : ''}`}>
      {showPis && <div className='permissions'>
        <img className='permissions-icon' src='/img/app/host-Info/icon_person_key.png' ></img>
        <div className='permissions-title'>{lang.setAdmin}</div>
        <img className='atv-per' onClick={this.setCheck} src={checkVlaue ? '/img/app/host-Info/check_onatv.png' : '/img/app/host-Info/check_noatv.png'} style={{ marginRight: `${isRtl(language) ? 'auto' : ''}`, marginLeft: `${isRtl(language) ? '' : 'auto'}` }} ></img>
      </div>}
      {false && showPis && userInfo.roleLevel == 2 && <div className='permissions'>
        <img className='permissions-icon' src='/img/app/host-Info/icon_person_mic.png' ></img>
        <div className='permissions-title'>{lang.sethost}</div>
        <img className='atv-per' onClick={this.setCheckHost} src={hostcheckVlaue ? '/img/app/host-Info/check_onatv.png' : '/img/app/host-Info/check_noatv.png'} style={{ marginRight: `${isRtl(language) ? 'auto' : ''}`, marginLeft: `${isRtl(language) ? '' : 'auto'}` }}></img>
      </div>}
      {false && roleLevel == 4 && <div className='permissions'>
        <img className='permissions-icon' src='/img/app/host-Info/icon_person_mic.png' ></img>
        <div className='permissions-title'>{lang.sethost}</div>
        <img className='atv-per' onClick={this.setCheckHost} src={hostcheckVlaue ? '/img/app/host-Info/check_onatv.png' : '/img/app/host-Info/check_noatv.png'} style={{ marginRight: `${isRtl(language) ? 'auto' : ''}`, marginLeft: `${isRtl(language) ? '' : 'auto'}` }}></img>
      </div>}
      {userInfo && <div className="usermyinfo-user">
        <div className="application-title">{lang.myInfoText}</div>
        <div className="info-title-after"></div>
        <div className="application-user-info">
          <div className="avatar-root">
            <img className="avatar-img" src={userInfo.avatarurl}></img>
            {userInfo.myGender == 1 && (
              <img className="img-gender" src="/img/app/tradeUnion/man_icon.png"></img>
            )}
            {userInfo.myGender == 2 && (
              <img className="img-gender" src="/img/app/tradeUnion/women_icon.png"></img>
            )}
          </div>
          <div className="user-info">
            <div className="user-info-top">
              <div className="top-text">{userInfo.nickname}</div>
              {userInfo.roleLevel == 3 && <div className="host-bg">{lang.host}</div>}
            </div>
            <div className="user-info-buttom">ID:{userInfo.duid}</div>
          </div>
          <div
          >
          </div>
        </div>
        <div className="info-text-item">
          <div className="item-text">{lang.bankNameText}</div>
          <div
            className="item-info"
          >{userInfo.bank}</div>
        </div>
        <div className="info-text-item">
          <div className="item-text">{lang.bankIdText}</div>
          <div
            className="item-info"
          >{userInfo.account}</div>
        </div>
        <div className="info-text-item">
          <div className="item-text">{lang.payeeName}</div>
          <div
            className="item-info"
          >{userInfo.payeeName}</div>
        </div>
      </div>}
    {/*   <div className='update' onClick={() => this.upHost()}>{lang.update}</div> */}
      {roleLevel != 4 && <ReminderBtn
        lang={this.state.lang}
        slotButtonComp={() => { return (<div className='remove'>{lang.remove}</div>) }}
        slotContentComp={this.showGoldModle}
      />}
      <Message ref="msg" />
    </div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/host-Info/index.js